import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiHost } from 'api/apiHost';
import { ArticleDtoResponseWidgetDto, ArticleSearchRequest } from 'model/ApiGateway';
import { requestHandler } from '@/store/handleRequestLanguage';

const customBaseQuery = fetchBaseQuery({
  baseUrl: `${apiHost}/api/articles/`,
});

const baseQueryHandler = async (args, api) => requestHandler(customBaseQuery, args, api);

export const articleSearch = createApi({
  reducerPath: 'articleSearch',
  baseQuery: baseQueryHandler, // should domain-based URL
  endpoints: (build) => ({
    articlesSearch: build.query<ArticleDtoResponseWidgetDto, ArticleSearchRequest>({
      query: (body) => ({
        url: 'Search',
        method: 'POST',
        body: body,
      }),
    }),
    getFacets: build.query({
      queryFn: async (_arg, _queryApi, _extraOptions, fetchWithBQ) => {
        const { data } = await fetchWithBQ({
          method: 'POST',
          body: _arg,
          url: 'Facets',
        });

        if (!data) return [];

        return {
          data: data?.map((filter) => ({
            label: filter.label,
            name: filter.name,
            displayName: filter.label,
            displayNameKey: '',
            options: filter.value
              .filter((option) => option.text.length !== 0)
              .map((option) => ({
                ...option,
                selected: false,
                applied: false,
                disabled: false,
                showAggregateCount: true,
                aggregateCount: option.count,
              })),
          })),
        };
      },
    }),
  }),
});

export const { useLazyArticlesSearchQuery, useLazyGetFacetsQuery } = articleSearch;
